// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__iQ3jr","pink":"About_pink__+JbkQ","green":"About_green__qf-qZ","skills":"About_skills__JEytk"};